export default "__VITE_ASSET__D6yzqYd9__"